// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify);
export default new Vuetify({
    iconfont: "mdi", // 'md' || 'mdi' || 'fa' || 'fa4'
    theme: {
        themes:{
            light: {
                primary: '#29B3A6',
                //secondary: '#b0bec5',
                dark: '#b0bec5',
                accent: '#006958',
                error: '#b71c1c',
                success: '#5cb85c',
                warning:'#f0ad4e',
                background: '#f8f8f8'
            },
        }
    },
});
